<template>
	<div class="engagement-header">
		<div class="event-head">
			{{ event.name }}
		</div>
		<div class="date-wrapper">
			<div class="quick-date">
				<a 
					v-for="option in quickDateOptions"
					:key="option.value"
					:class="{ active: quickDate === option.value}"
					@click="quickDateSelect(option.value)">
						<span>
							{{option.name}}
						</span>
						
				</a>
			</div>
			<div class="picker-date">
				<DateRangePicker
					:date-set="dateRange"
					@date-select="changeDate"
					></DateRangePicker>
			</div>
		</div>
		
	</div>
</template>

<script>
import DateRangePicker from '@/module/component/DateRangePicker'

export default {
	name: 'engagement-header',
	props: {
		event: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			dateRange: '',
			quickDate: ''
		}
	},
	created() {
		this.defaultValue = (new Date()).toLocaleDateString()
		this.defaultTime = ['00:00:00', '00:00:00']
		this.quickDateOptions = [
			{
				name: 'today',
				value: 'today'
			},
			{
				name: 'tomorrow',
				value: 'tomorrow'
			},
			{
				name: 'next week',
				value: 'next-week'
			},
			{
				name: 'next 2 week',
				value: 'next-2-week'
			}
		]
		this.quickDateSelect('today')
	},
	methods: {
		quickDateSelect(quickDate) {
			//console.log(quickDate)
			this.quickDate = quickDate
			const today = new Date()
			switch (quickDate) {
				case 'today':
					this.dateRange = [today, '']
					break
				case 'tomorrow':
					let tomorrow = new Date()
					tomorrow.setDate(today.getDate() + 1)
					this.dateRange = [ tomorrow, '']
					break
				case 'next-week':
					let nextWeek = new Date()
					nextWeek.setDate(today.getDate() + 7)
					this.dateRange = [today, nextWeek]
					break
				case 'next-2-week':
					let next2Week = new Date()
					next2Week.setDate(today.getDate() + 14)
					this.dateRange = [today, next2Week]
					break
				default:
					break
			}
			this.$emit('date-select', [...this.dateRange])
		},
		changeDate(dateRange) {
			this.dateRange = dateRange
			this.$emit('date-select', [...this.dateRange])
		}
	},
	components: {
		DateRangePicker
	}
}
</script>

<style scoped>
	.picker-date{
		margin-left: 20px;
	}
	.picker-date>.el-range-editor{
		border: 1px solid #2d3e4f;
	}
	.picker-date >>> .el-range-separator{
		font-size: 20px;
		margin-top: 10px;
		color: #cccccc;
	}
</style>

<style lang="scss" scoped>
	.event-head{
		padding: 18px 14px;
		font-size: 20px;
		font-weight: 700;
		text-transform: capitalize;
	}
	.date-wrapper{
		display: flex;
		padding-bottom: 18px;
	}
	.engagement-header{
		background-color: #f0f7ff;
	}
	.quick-date{
		padding: 14px 0px;
		&>a{
			color: #2d3e4f;
			text-transform: uppercase;
			font-size: 14px;
			text-align: center;
			padding: 0px 14px;
			border-right: 1px solid #2d3e4f;
			cursor: pointer;
		}
		&>a:last-child{
			border-right: none;
		}
		&>a>span{
			padding-bottom: 2px;
		}
		&>a.active>span{
			font-weight: 700;
			border-bottom: 1px solid #2d3e4f;
		}
	}
</style>

